<template>
	<div class="nav">
		<div class="center">
			木棉树软件创新中心3D可视化
		</div>
		<div class="left">
			<div v-if="backflag" class="back" @click="goback()"><img src="../../assets/img/back.png" ><p>返回</p></div>
			<img v-if="backflag" src="../../assets/img/jux.png" alt="">
			<div><img src="../../assets/img/navtime.png" alt=""><p>{{nowTime}}</p></div>
			<img src="../../assets/img/jux.png" alt="">
			<div><img src="../../assets/img/navwater.png" ><p>{{weather}}</p></div>
		</div>
		<div class="right">
			<div><img src="../../assets/img/navrq.png" alt=""><p>{{nowDate}}</p></div>
			<img src="../../assets/img/jux.png" alt="">
			<div><img src="../../assets/img/week.png" alt=""><p>{{weekday}}</p></div>
		</div>
	</div>
</template>

<script>
	import {weather} from '../../request/api.js'
	export default {
	  name: "Home",
	  data() {
	  	return{
			nowTime:'',
			nowDate:'',
			weather:'小雨',
			weekday:'',
		}
	  },
	  props:['backflag'],
	  methods: {
	    getTime(){
	         let date = new Date(); //获取当前日期信息
	         let year = date.getFullYear() //获取当前年
	         let month = date.getMonth() + 1 //获取当前月
	         let day = date.getDate() //获取当前天
	         let week = date.getDay() //获取星期
	         let hour = date.getHours() //获取当前小时
	         let minutes = date.getMinutes() //获取当前分
	         let seconds = date.getSeconds() //获取当前小时
			 // console.log(week)
			 var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
			 this.weekday = weeks[week];
	         this.nowTime = this.covert(hour) + ':' + this.covert(minutes) + ':' + this.covert(seconds)
	         this.nowDate = year + '-' + this.covert(month) + '-' + this.covert(day)
	     },
		covert(arg){
			return arg < 10 ? '0'+arg : arg
		 },
		 goback(){
			 document.getElementById('iframe').contentWindow.goback()
		 }
	  },
	  
	  mounted() {
	     setInterval(this.getTime,1000)
		
	  }
	};
</script>

<style scoped="scoped">
	.nav{
		position: absolute;
		top: 0;
		left: 0;
		z-index: 3;
		width: 100%;
		height: 10vh;
		background:url(../../assets/img/nav1.png) no-repeat,linear-gradient(to bottom ,rgba(15, 32, 53,1) , rgba(15, 32, 53,0));
		background-size: 100% auto;
		font-family: 'rul';
		/* background-color:; */
	}
	.center{
		position: absolute;
		top: 1.5vh;
		left: 50%;
		-webkit-transform: translateX(-50%) /* translateY(-50%) */;
		height: 5vh;
		line-height: 4.5vh;
		font-size: 1.5vw;
		font-weight: bold;
		color: #EFF6FF;
	}
	.right{
		position: absolute;
		height:5vh;
		/* background: red; */
		top: 1.5vh;
		left: 0;
		display: flex;
		box-sizing: border-box;
		padding: 0 15px;
		justify-content:space-between;
		align-items:center;
	}
	.right>img{
		width: 2px;
		height: 30%;
		margin:0 1.5vw;
	}
	.right>div{
		display: flex;
		justify-content:center;
		align-items:center;
	}
	.right>div>img{
		width: 1.9vh;
		height: 1.9vh;
	}
	.right>div>p{
		margin-left: .5vw;
		font-size: 0.8vw;
		font-weight: 400;
		color: #FFFFFF;
	}
	.left{
		position: absolute;
		top: 1.5vh;
		right: 0;
		height: 5vh;
		display: flex;
		box-sizing: border-box;
		padding: 0 15px;
		justify-content:space-between;
		align-items:center;
	}
	.left>img{
		width: 2px;
		height: 30%;
		margin:0 1vw;
	}
	.left>div{
		display: flex;
		justify-content:center;
		align-items:center;
	}
	.left>div>img{
		width: 1.9vh;
		height: 1.9vh;
	}
	.left>div>p{
		margin-left: .5vw;
		font-size: 0.8vw;
		font-weight: 400;
		color: #FFFFFF;
	}
	.back{
		cursor: pointer;
	}
</style>
